module.exports = __webpack_public_path__ + "assets/img/96f1a277c54c9ee337891a424c79bfa2.svg";